import { render } from "./ShadowDom.vue?vue&type=template&id=2acfbf3a&ts=true"
import script from "./ShadowDom.vue?vue&type=script&lang=ts"
export * from "./ShadowDom.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__